import React, { useContext, useEffect, useState } from 'react';
import { FaUserCircle, FaPlay, FaDollarSign, FaMusic, FaMoneyBill, FaRupeeSign } from 'react-icons/fa';
import { MdGraphicEq } from 'react-icons/md';
import Header from '../components/Header';
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import PieChartComponent from '../components/charts/PieChartComponent';
import LineChartComponent from '../components/charts/LineChartComponent';
import { calculatePerformanceIncrease } from '../utils/calculationHelpers';
import PerformanceCard from '../components/PerformanceCard';
import Button from '../components/custom_ui/button.tsx';
import { useNavigate } from 'react-router-dom';
import SongsTable from '../components/SongsTable';

const ArtistDashboardPage = () => {
    const authContext = useContext(AuthContext);
    const { getArtistDashboardData, applicationData, dataLoading } = useContext(DataContext);
    const [mounted, setMounted] = useState(true);
    const navigate = useNavigate();

  

    useEffect(() => {
         console.log(authContext.isAuthenticated," login ",authContext.isAdmin)
        if (authContext.isAuthenticated){
            if(authContext.isAdmin){
                navigate("/admin_dashboard")
                return
            }
        }else{
            navigate("/artist_login")
            return
        }
        if (mounted) {
            getArtistDashboardData();
        }
        return () => setMounted(false);
    }, [mounted, getArtistDashboardData]);

    const performance = applicationData ? calculatePerformanceIncrease(applicationData.barchartdata, 'month') : {};

    return (
        <div className="bg-background relative">
            {dataLoading && (
                <div className="absolute inset-0 bg-background/30 flex justify-center items-center z-50">
                    <div className="spinner"></div>
                </div>
            )}
            <div className='absolute top-0 left-0 right-0'>
                <Header />
            </div>

            <div className="min-h-screen text-white pt-28 py-6 px-4 sm:px-6 lg:px-8 ">
                <div className="max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="bg-gradient-card border border-border/50 flex items-center justify-between mb-6 px-6 py-4 rounded-md">
                        <div className="flex items-center">
                            <FaUserCircle className="text-primary text-xl mr-2" />
                            <div>
                                <h1 className="text-xl font-semibold">Artist Portal</h1>
                                <p className="text-muted-foreground text-sm">Track Your Music Performance</p>
                            </div>
                        </div>

                        <Link to="/withdraw-request-artist" title="Withdrawal Requests">
                            <FaMoneyBill size={24} className="text-gold hover:text-gold-light" />
                        </Link>
                    </div>

                    {/* Welcome Banner */}
                    <div className="bg-gradient-gold border border-border/50 rounded-xl p-6 mb-6">
                        <h2 className="text-primary-white text-xl font-semibold mb-2">Welcome back, {authContext.artist ? authContext.artist.name : " Artist!"}</h2>
                        <p className="text-muted/80 text-sm mb-3">Here's how your music is performing across all platforms</p>
                        <div className="flex items-center text-white text-sm space-x-4">
                            <p className='text-secondary'><FaMusic className="inline-block mr-1 text-secondary" /> {applicationData ? applicationData.total_platforms : "0"} platforms</p>
                            <p className='text-secondary'><FaMusic className="inline-block mr-1 text-secondary" /> {applicationData ? applicationData.total_songs : "0"} active songs</p>
                        </div>
                    </div>

                    {/* Performance Overview */}
                    <div className="mb-8">
                        <h2 className="text-lg font-semibold mb-4">
                            <MdGraphicEq className="inline-block mr-2 text-purple-400" /> Performance Overview
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <PerformanceCard title="Total Songs" value={applicationData ? applicationData.total_songs : "0"} icon={<FaMusic className="text-gray-400" />} increase={performance.songs_increase || 0} />
                            <PerformanceCard title="Total Views" value={applicationData ? applicationData.total_views : "0"} icon={<FaPlay className="text-gray-400" />} increase={performance.views_increase || 0} />
                            <PerformanceCard title="Total Royalty" value={`₹${applicationData ? (applicationData.total_royalty || 0).toFixed(2) : "0.00"}`} icon={<FaRupeeSign className="text-gray-400" />} increase={performance.royalty_increase || 0} />
                        </div>
                    </div>

                    {/* Monthly Growth & Platform Distribution */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <PieChartComponent applicationData={applicationData} />
                        <LineChartComponent applicationData={applicationData} />
                    </div>

                    {/* Songs Table */}
                    {applicationData && applicationData.songs && (
                        <SongsTable songsData={applicationData.songs} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ArtistDashboardPage;